import { render, staticRenderFns } from "./SelectRejectMsg.vue?vue&type=template&id=c3001022&"
import script from "./SelectRejectMsg.vue?vue&type=script&lang=js&"
export * from "./SelectRejectMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports